import React from "react";
import handsPic from "../../img/hands-register.png";
import {
  FaBan,
  FaFileInvoiceDollar,
  FaFolderOpen,
  FaHandshake,
  FaRoute,
  FaTruck,
  FaTruckLoading,
  FaLaptopCode,
} from "react-icons/fa";
import { FaMoneyBillTrendUp, FaCalendarXmark } from "react-icons/fa6";
import "./Services.css";
import Footer from "../../components/Footer/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

const Services = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <>
      <div data-aos="fade-up" className="services-container mb-5">
        <div className="container mt-5">
          <div className="row">
            <div data-aos="fade-right" className="col-md-6">
              <img src={handsPic} alt="" />
            </div>
            {/* <div className="col-md-1"></div> */}
            <div data-aos="fade-left" className="col-md-6">
              <div className="title-container py-4">
                <h2 className="text-center ">OUR SERVICES</h2>
                <p className="text-center mt-4 px-5 services-text">
                  We offer a full range of professional dispatching services
                  designed to keep your business running smoothly and
                  profitably. From securing top-paying loads to handling
                  paperwork and negotiations, our team takes care of the details
                  for you. We focus on efficiency, reliability, and clear
                  communication at every step. Our goal is to reduce your stress
                  and maximize your earnings on the road. With our support, you
                  can stay focused on driving while we manage the rest. We are
                  committed to helping your trucking business grow with
                  confidence.
                </p>
              </div>
            </div>
          </div>

          <div className="services-content mt-5">
            <div className="row mt-4">
              <div className="col-md-4">
                <div className="service">
                  <div data-aos="fade-up" className="card ">
                    <div className="service-logo mb-4">
                      <FaTruck size={50} color="red" />
                    </div>
                    <div className="service-text">
                      <h3>Dedicated Dispatchers</h3>
                      <p className="m-0">
                        Our dedicated dispatchers work closely with you to
                        understand your business needs and preferences. They
                        manage your loads, communicate with brokers, and ensure
                        smooth coordination at every step. With a personal
                        dispatcher assigned to you, you get consistent support
                        and better decision-making.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="service">
                  <div data-aos="fade-up" className="card ">
                    <div className="service-logo mb-4 ">
                      <FaMoneyBillTrendUp size={50} color="red" />
                    </div>
                    <div className="service-text">
                      <h3>Top Paying Loads</h3>
                      <p className="m-0">
                        We focus on securing the highest-paying loads available
                        in the market for our clients. Our team actively
                        searches multiple load boards and negotiates with
                        brokers to maximize your revenue. We analyze routes and
                        demand to ensure you’re getting the best possible rates.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="service">
                  <div data-aos="fade-up" className="card ">
                    <div className="service-logo mb-4 ">
                      <FaFolderOpen size={50} color="red" />
                    </div>
                    <div className="service-text">
                      <h3>Carrier Packet Setup</h3>
                      <p className=" m-0">
                        We handle the complete setup of your carrier packet with
                        brokers to save you time and hassle. Our team ensures
                        all necessary documents are properly completed and
                        submitted. This helps speed up the booking process and
                        reduces delays. We maintain organized records for easy
                        access whenever needed.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-4">
                <div className="service">
                  <div data-aos="fade-up" className="card ">
                    <div className="service-logo mb-4 ">
                      <FaHandshake size={50} color="red" />
                    </div>
                    <div className="service-text">
                      <h3>Rate Negotiations</h3>
                      <p className=" m-0">
                        Our experienced team negotiates directly with brokers to
                        get you the best possible rates. We understand market
                        trends and use that knowledge to your advantage. Instead
                        of accepting low offers, we push for fair and
                        competitive pricing. This ensures you are properly
                        compensated for your work.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="service">
                  <div data-aos="fade-up" className="card ">
                    <div className="service-logo mb-4 ">
                      <FaFileInvoiceDollar size={50} color="red" />
                    </div>
                    <div className="service-text">
                      <h3>Invoicing Paperwork</h3>
                      <p className="m-0">
                        We take care of all invoicing and paperwork to ensure
                        you get paid on time. Our team prepares and submits
                        invoices accurately to avoid delays. We keep track of
                        all documents and follow up when necessary. This reduces
                        administrative stress on your end.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="service">
                  <div data-aos="fade-up" className="card ">
                    <div className="service-logo mb-4 ">
                      <FaTruckLoading size={50} color="red" />
                    </div>
                    <div className="service-text">
                      <h3>Handle Lumper/Detention</h3>
                      <p className="m-0">
                        We manage lumper fees and detention requests on your
                        behalf. Our team communicates with brokers and
                        facilities to ensure you are fairly compensated. Waiting
                        time and extra charges are properly documented and
                        claimed. This helps prevent financial losses due to
                        delays.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-md-4">
                <div className="service">
                  <div data-aos="fade-up" className="card ">
                    <div className="service-logo mb-4 ">
                      <FaBan size={50} color="red" />
                    </div>
                    <div className="service-text">
                      <h3>No Forced Dispatch</h3>
                      <p className=" m-0">
                        You have full control over which loads you choose to
                        accept. We present options, but the final decision is
                        always yours. There is no pressure to take loads that
                        don’t meet your expectations. This flexibility allows
                        you to work on your own terms. We respect your
                        preferences and business goals.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="service">
                  <div data-aos="fade-up" className="card ">
                    <div className="service-logo mb-4 ">
                      <FaCalendarXmark size={50} color="red" />
                    </div>
                    <div className="service-text">
                      <h3>No Time-Bound Contract</h3>
                      <p className="m-0">
                        We believe in earning your trust without locking you
                        into long-term contracts. You can work with us without
                        any binding commitments. This gives you the freedom to
                        continue based on satisfaction. Our services are
                        designed to retain clients through quality, not
                        obligation.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="service">
                  <div data-aos="fade-up" className="card ">
                    <div className="service-logo mb-4 ">
                      <FaRoute size={50} color="red" />
                    </div>
                    <div className="service-text">
                      <h3>Route Planning</h3>
                      <p className=" m-0">
                        We carefully plan routes to maximize efficiency and
                        reduce dead miles. Our team considers fuel costs,
                        traffic, and delivery schedules. Smart routing helps you
                        save time and increase profitability. We ensure smoother
                        trips with fewer complications. Better planning means
                        less stress on the road.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-md-4"></div>
              <div className="col-md-4">
                <div className="service">
                  <div data-aos="fade-up" className="card ">
                    <div className="service-logo mb-4 ">
                      <FaLaptopCode size={50} color="red" />
                    </div>
                    <div className="service-text">
                      <h3>Web Development</h3>
                      <p className=" m-0">
                        We build and redesign professional, responsive websites
                        specifically for trucking companies. Our websites are
                        designed to showcase your services, attract brokers,
                        shippers and build trust with potential clients. From
                        modern layouts and service pages to contact forms and
                        mobile-friendly designs, we create a strong online
                        presence that helps your business grow.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4"></div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Services;
